import React from 'react';
import { IconBuildingCommunity } from '@tabler/icons';

import { Container } from './styles';

interface ButtonProps {
  name?: string;
  location?: string;
  [x: string]: any;
}

const Button: React.FC<ButtonProps> = ({
  name,
  location,
  children,
  isLoading,
  ...rest
}) => {
  return (
    <Container {...rest}>
      <div>
        <IconBuildingCommunity size={25} color="#0075FF" />
      </div>

      <div>
        <h3>{name}</h3>
        <p>{location}</p>
      </div>
    </Container>
  );
};

export default Button;
